module.exports = __webpack_public_path__ + "img/AveMonthlyRent2.6228b7c5.jpg";